'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createReducer = exports.reducer = exports.actions = exports.PagerDefault = exports.default = undefined;

var _Pager = require('./components/Pager');

var _Pager2 = _interopRequireDefault(_Pager);

var _actions = require('./actions');

var actions = _interopRequireWildcard(_actions);

var _reducer = require('./reducer');

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Pager2.default;
exports.PagerDefault = _Pager.PagerDefault;
exports.actions = actions;
exports.reducer = _reducer2.default;
exports.createReducer = _reducer.createReducer;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-pagination/lib/index.js
// module id = 78
// module chunks = 1